<div class='distributor-companies-switch'>
  <form class='distributor-companies-search' [class.hide]='!isSearchFilterShown'>
    <input
      type='text'
      class='search-field'
      placeholder="{{ 'GENERIC.search' | translate }}"
      matInput
      [formControl]='searchFilterFormControl'
      [matAutocomplete]='auto'
      #searchFilter
    />

    <mat-autocomplete
      autoActiveFirstOption
      #auto='matAutocomplete'
      overlayPanelClass='hide'
      (optionSelected)='companySelected($event)'
    >
      <mat-option
        *ngFor='let company of filteredCompanies | async'
        [value]='company'
        [class.active-company]='cService.userProfile.company.toLowerCase() == company.toLowerCase()'
        [style.color]="
					cService.userProfile &&
					cService.userProfile.HqColour &&
					cService.userProfile.company.toLowerCase() === company.toLowerCase()
						? '#' + cService.userProfile.HqColour
						: ''
				"
      >
        {{ company }}
      </mat-option>
      <mat-option disabled *ngIf='(filteredCompanies | async)?.length === 0'>
        {{ 'MESSAGESANDWARNINGS.noResultsFound' | translate }}
      </mat-option>
    </mat-autocomplete>
  </form>

  <button
    mat-button
    class='distributor-switch sharp-corners'
    [class.hide]='isSearchFilterShown'
    (click)='showSearchFilter()'
    fxFlex
    [disabled]='isReadonly'
    [matTooltip]="isReadonly ? 'MAINSIDENAV.company' : ('SECURITY.switchCompany' | translate)"
  >
		<span data-cy='company-name' [style.color]='vrmPrimaryColor' class='bold'>{{
      cService.userProfile.company
      }}</span>
    <mat-icon
      *ngIf='!isReadonly'
      [style.color]='vrmPrimaryColor'
      style='position: relative'
      [style.top]='dropDownIconPosInPx'
    >
      arrow_drop_down
    </mat-icon
    >
  </button>
</div>
